<template>
	<!-- We use v-on:input as well as v-model because we need to use nextTick to bubble up the event to the parent -->
	<!-- <select2 :options="memberOptions" v-model="selectedMemberId" v-on:input="emitSelectedItem()"></select2> -->
	<multiselect v-model="selectedMembers" :options="memberOptions" track-by="id" label="name" @input="emitSelectedItem()" :multiple="multipleSelect"></multiselect>
</template>

<script>

	export default {
        props: {
            role_type: {
            	type: String,
            	default: ""
            },
            role: {
            	type: String,
            	default: ""
            },
            value: {
            	type: Array,
            	default: []
            },
            multiple: {
            	type: Boolean,
            	default: false
            }
        },
		data: function () {
			return {
				memberOptions: [],
				selectedMembers: [],
				filterRoleType: this.role_type,
				filterRole: this.role,
				multipleSelect: this.multiple,
				loading: false
			}
		},
		mounted() {
			console.log('Member options component mounted.');
			this.getMembers();
		},
        computed: {
            memberFilters : function() {
                var filters = [];
                // 'training_date:2018-01-01~~2018-03-01&format=chartjs'
                // We always have a date range filter
                if (this.role != "") {
                    filters.push('role:' + this.role);
                }
                if (this.role_type != "") {
                    filters.push('role_type:' + this.role_type);
                }
                return 'filters=' + filters.join();
            },
        },
		methods: {
			getMembers() {
				if (this.loading == false) {
					this.loading = true;

					// Note, in some cases you need to put:
					// 
					// 		var vm = this;
					// 		
					// here and the inside the promise function, you reference "vm" instead of "this". 
					// This is due to a "function" having its own context.
					// However since we use => syntax this isn't necessary because arrow functions don't declare their own scope
					// @see https://stackoverflow.com/questions/47148363/when-to-use-vm-or-this-in-vue-js
										
					axios.get('/api/v1/members?' + this.memberFilters).then((response) => {
						this.memberOptions = [];
						this.memberOptions.push({id:0, label: "-- Please Select --"})
						console.log('Value prop is : ' + this.value);
						console.log('API response:');
						console.log(response.data);
						for (var member of response.data) {
							console.log('Checking member object: ' + member.id);
							if (_.includes(this.value, member.id)) {
								console.log('Setting this.selectedMember')
								this.selectedMembers.push(member);
							}
							this.memberOptions.push(member);
						}
						this.loading = false;
					}).catch((error) => {
						this.loading = false;
						this.handleHTTPError(error);
					});
				} else {
					this.loading = false;
					this.memberOptions = [];
				}
			},
			emitSelectedItem() {
				console.log('Member changed');
				// We use nextTick because we have to wait for the value of the select2 to update
				this.$nextTick(function() {
					var selectValue = _.map(this.selectedMembers, 'id');
					if (this.multipleSelect === false) {
						selectValue = this.selectedMembers.id;
					}
					this.$emit('input', selectValue);
				})
			},
			handleHTTPError(error) {
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log(error.response.data); // Error message
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
			}

		}
	}
</script>